export default {
    to: "/dashboard/sasapay-products/customer-to-business",
    order: 3,
    icon: "mdi-room-service",
    title: "Customer To Business",
    disabled: false,
    value: 0,
    // sublinks: [
    //     {
    //         to: "/dashboard/sasapay-products/register-callback",
    //         order: 3,
    //         icon: "mdi-cash-register",
    //         title: "Callback URL",
    //         disabled: false,
    //         value: 0,
    //     },
    //     {
    //         to: "/dashboard/sasapay-products/customer-to-business",
    //         order: 3,
    //         icon: "mdi-account-search",
    //         title: "Customer To Business",
    //         disabled: false,
    //         value: 0,
    //     },
    // ],
}
